import { render } from "./HeaderComponent.vue?vue&type=template&id=37d28699"
import script from "./HeaderComponent.vue?vue&type=script&lang=js"
export * from "./HeaderComponent.vue?vue&type=script&lang=js"

import exportComponent from "E:\\myFolders\\javascript\\frameworks\\vue\\practice\\local\\local-vue-practice-v2\\fourth-day\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__